import { cva } from '@/styled-system/css';

export const textButtonIconRecipe = cva({
  base: {},

  variants: {
    tone: {
      brand: {
        color: { base: 'TextButton.brand.icon.default' },
      },
      neutral: {
        color: { base: 'TextButton.neutral.icon.default' },
      },
      subtle: {
        color: { base: 'TextButton.subtle.icon.default' },
      },
    },
    onImpact: {
      true: {
        color: { base: 'TextButton.onImpact.neutral.icon.default' },
      },
      false: {},
    },
    disabled: {
      true: {},
      false: {},
    },
    size: {
      sm: {},
      md: {},
    },
  },

  compoundVariants: [
    {
      tone: 'brand',
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.brand.icon.hover',
          _groupActive: 'TextButton.brand.icon.pressed',
        },
      },
    },
    {
      tone: 'neutral',
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.neutral.icon.hover',
          _groupActive: 'TextButton.neutral.icon.pressed',
        },
      },
    },
    {
      tone: 'subtle',
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.subtle.icon.hover',
          _groupActive: 'TextButton.subtle.icon.pressed',
        },
      },
    },
    {
      onImpact: true,
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.onImpact.neutral.icon.hover',
          _groupActive: 'TextButton.onImpact.neutral.icon.pressed',
        },
      },
    },
  ],
});
